<dx-chart class="catchup-chart-style"
          [dataSource]="chartData"
          [series]="series"
          [pathModified]="true"
          [customizePoint]="customiseChartPoint"
          (onPointClick)="onPointClicked($event)">
    <!-- zIndex value from old ajs chart - tried taking it away and tooltip will be hiding behind the dialog -->
    <dxo-chart-tooltip [enabled]="true"
                       [zIndex]="99999999"
                       contentTemplate="tooltipContent"></dxo-chart-tooltip>
    <dxo-chart-title [text]="title"></dxo-chart-title>
    <dxi-chart-value-axis [visualRange]="[-0.5, 2.5]"
                          visualRangeUpdateMode="keep"
                          [maxValueMargin]="0.001"
                          [tickInterval]="0.5"
                          [visible]="true">
        <dxo-chart-label [visible]="true"
                         [customizeText]="customiseLabel"></dxo-chart-label>
        <dxo-chart-minor-tick [visible]="false"></dxo-chart-minor-tick>
        <dxo-chart-tick [visible]="false"></dxo-chart-tick>
        <dxo-chart-grid [visible]="false"></dxo-chart-grid>
        <dxo-chart-minor-grid [visible]="false"></dxo-chart-minor-grid>
        <dxi-chart-constant-line dashStyle="solid"
                                 [width]="1"
                                 color="#ababab"
                                 [value]="-0.5"> </dxi-chart-constant-line>
        <dxi-chart-constant-line dashStyle="dash"
                                 [width]="1"
                                 color="#ababab"
                                 [value]="0.5"> </dxi-chart-constant-line>
        <dxi-chart-constant-line dashStyle="dash"
                                 [width]="1"
                                 color="#ababab"
                                 [value]="1.5"> </dxi-chart-constant-line>
        <dxi-chart-constant-line dashStyle="solid"
                                 [width]="1"
                                 color="#ababab"
                                 [value]="2.5"> </dxi-chart-constant-line>
    </dxi-chart-value-axis>
    <dxo-chart-argument-axis type="discrete">
        <dxo-chart-label overlappingBehavior="rotate"
                         [rotationAngle]="-45"
                         [format]="DateFormats.globalize.short"
                         [visible]="!hideDates"> </dxo-chart-label>
    </dxo-chart-argument-axis>
    <dxo-chart-legend [visible]="false"></dxo-chart-legend>

    <div *dxTemplate="let info of 'tooltipContent'"
         class="catchup-chart-tooltip">
        <adapt-display-catchup-rating [rating]="info.point.tag"
                                      [showCommentDetails]="true"
                                      [showButtons]="false"></adapt-display-catchup-rating>
    </div>
</dx-chart>
